const footer = {
  copyright: "حقوق النشر© HitPaw. Co., Ltd 2022.كل الحقوق محفوظة.",
};

export default footer;
